import React from 'react';
import { Stack, Typography } from '@mui/material';
import { ListCard } from 'components/Card';
import { Status as StatusComponent } from 'components/Status';
import { isoToDateString } from 'utils/dateFormatter';

export const VersionCard = ({ version, created_at, end_date, actual_end_date, status }) => {
  return (
    <ListCard>
      <Stack flex={4} justifyContent="center">
        <Typography variant="caption">Version</Typography>
        <Typography variant="body2" fontWeight={600}>
          {version}
        </Typography>
      </Stack>
      <Stack flex={1.5} justifyContent="center" sx={{ pr: 2 }}>
        <Typography variant="caption">Date posted</Typography>
        <Typography variant="body2" fontWeight={600}>
          {isoToDateString(created_at, false)}
        </Typography>
      </Stack>
      <Stack flex={{md: 1.7, lg: 1.5}} justifyContent="center" sx={{ pr: 2 }}>
        <Typography variant="caption">Planned end date</Typography>
        <Typography variant="body2" fontWeight={600}>
          {isoToDateString(end_date, false)}
        </Typography>
      </Stack>
      <Stack flex={1.5} justifyContent="center" sx={{ pr: 2 }}>
        <Typography variant="caption">Actual end date</Typography>
        <Typography variant="body2" fontWeight={600}>
          {actual_end_date ? isoToDateString(actual_end_date, false) : '-'}
        </Typography>
      </Stack>
      <StatusComponent status={status} additionalColor />
    </ListCard>
  );
};